import { gql } from '@apollo/client';
import {
  QUESTIONNAIRE_FRAGMENT,
  QUESTIONNAIRE_COMPANY_RESPONSE_FRAGMENT,
  BASE_QUESTIONNAIRE_FRAGMENT,
} from 'graphql/secure/fragments/questionnaire.fragments';

export const CREATE_QUESTIONNAIRE = gql`
  mutation CreateQuestionnaire($input: CreateQuestionnaireInput!) {
    createQuestionnaire(input: $input) {
      questionnaire {
        ...baseQuestionnaireValues
      }
    }
  }
  ${BASE_QUESTIONNAIRE_FRAGMENT}
`;

export const UPDATE_QUESTIONNAIRE = gql`
  mutation UpdateQuestionnaire($id: UUID!, $input: UpdateQuestionnaireInput!) {
    updateQuestionnaire(id: $id, input: $input) {
      questionnaire {
        ...baseQuestionnaireValues
      }
    }
  }
  ${QUESTIONNAIRE_FRAGMENT}
`;

export const UPDATE_QUESTIONNAIRE_ANSWERS = gql`
  mutation UpdateQuestionnaireAnswers($id: UUID!, $inputs: [UpdateQuestionnaireAnswersInput!]!) {
    updateQuestionnaireAnswers(questionnaireCompanyResponseId: $id, inputs: $inputs) {
      questionnaireCompanyResponse {
        ...questionnaireCompanyResponseValues
      }
    }
  }
  ${QUESTIONNAIRE_COMPANY_RESPONSE_FRAGMENT}
`;
